import template from "./validation-callout.html";
import "./validation-callout.less";
import {
	filter,
	size,
	some,
	orderBy,
	compact,
	uniqBy,
	groupBy
} from "lodash";
import { REPORT_SCOPES } from "../../constants";

export function controller($logger) {
	const ctrl = this;
	const limitTo = 3;

	ctrl.$onChanges = onChanges;
	ctrl.ruleTitles = {};

	function onChanges() {
		if(!ctrl.validations)
			return;

		const types = ctrl.validations.map(o => {
			let rules = [...filter(o.rules, (r) => some(ctrl.scopes, (s => r.validationScope.Code === s)))];

			let validationQty = 0;
			let detailValidationQty = 0;

			if(ctrl.scopes.indexOf(REPORT_SCOPES.detail) < 0) {
				const detailValidations = o.rules.filter((err) => err.validationScope.Code === REPORT_SCOPES.detail && err.DetailId !== undefined);
				detailValidationQty = uniqBy(detailValidations, e => e.DetailId).length;

				if(detailValidationQty === 0) {
					detailValidationQty = undefined;
				}
			}

			validationQty = rules.length;

			const groupedValidations = groupBy(rules, rule => rule.Id);
			rules = uniqBy(rules, rule => rule.Id);

			ctrl.ruleTitles = rules.reduce((acc, rule) => {
				acc[rule.Id] = rule.Title;
				if(!groupedValidations[rule.Id].length > 1)
					return;

				if(rule.validationScope?.Code === REPORT_SCOPES.report || rule.validationScope?.Code === REPORT_SCOPES.metadata) {
					validationQty = validationQty - groupedValidations[rule.Id].length + 1;
				}
				else if(rule.validationScope?.Code !== REPORT_SCOPES.detail) {
					if(!rule.Engine?.IsAggregate)
						acc[rule.Id] = `(${groupedValidations[rule.Id].length} ${size(groupedValidations) === 1 ? "detail" : "details"}) ${rule.Title}`;
				}
				return acc;
			}, { ...ctrl.ruleTitles });

			if(validationQty > 0 || detailValidationQty > 0) {
				return {
					...o,
					rules: rules,
					message: validationQty > 0 ? o.message(validationQty) : "",
					messageSubmitted: validationQty > 0 && o.messageSubmitted ? o.messageSubmitted(validationQty) : "",
					detailMessage: detailValidationQty > 0 ? o.detailMessage(detailValidationQty) : "",
					detailMessageSubmitted: detailValidationQty > 0 && o.detailMessageSubmitted ? o.detailMessageSubmitted(detailValidationQty) : "",
					showAll: rules.length <= limitTo,
					limit: rules.length > limitTo ? limitTo : undefined
				};
			}
		});

		ctrl.types = orderBy(compact(types), ["critical"], ["asc"]);
	}
}

export default angular
	.module("vesl.components.validation-callout", [])
	.component("validationCallout", {
		template,
		controller,
		bindings: {
			validations: "<",
			scopes: "=",
			isSubmitted: "<"
		}
	}).name;
